var render, staticRenderFns
import script from "./TerminalBalance.vue?vue&type=script&lang=js"
export * from "./TerminalBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a297f5')) {
      api.createRecord('46a297f5', component.options)
    } else {
      api.reload('46a297f5', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/rights/fee/terminal_balance/TerminalBalance.vue"
export default component.exports